import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import AnalyticsTracker from "components/AnalyticsTracker";
import NotFound from "pages/NotFound";
import { AdminRoute, ProtectedRoute } from "./auth/ProtectedRoute";
import AdminDashboard from './pages/admin-dashboard';
import UserProfileDashboard from './pages/user-profile-dashboard';
import ChallengeDetail from './pages/challenge-detail';
import ChallengeCreation from './pages/challenge-creation';
import LoginRegistration from './pages/login-registration';
import ProjectDashboard from './pages/project-dashboard';
import ProofDetailView from './pages/proof-detail-view';
import ProjectDetail from './pages/project-detail';
import ProofSubmission from './pages/proof-submission';
import ProjectCreation from './pages/project-creation';
import People from './pages/people';
import PeopleUser from './pages/people-user';
import ResetPassword from './pages/reset-password';
import Landing from './pages/landing';
import NoticeDetail from './pages/notice-detail';
import NoticesPage from './pages/notices';
import AdminNoticeEditor from './pages/admin-notice-editor';
import NeighborsPage from './pages/neighbors';
import LabsPage from './pages/labs';
import LabsDetail from './pages/labs-detail';
import LabsEditor from './pages/labs-editor';
import FeedPage from './pages/feed';
import FeedDetail from './pages/feed-detail';
import FeedEditor from './pages/feed-editor';
import Rankings from './pages/rankings';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <AnalyticsTracker />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Landing />} />
        <Route path="/notices" element={<NoticesPage />} />
        <Route path="/notice-detail" element={<NoticeDetail />} />
        <Route path="/labs" element={<LabsPage />} />
        <Route path="/labs-detail" element={<LabsDetail />} />
        <Route
          path="/labs-editor"
          element={
            <ProtectedRoute>
              <LabsEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-dashboard"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route
          path="/admin-notice-editor"
          element={
            <AdminRoute>
              <AdminNoticeEditor />
            </AdminRoute>
          }
        />
        <Route
          path="/user-profile-dashboard"
          element={
            <ProtectedRoute>
              <UserProfileDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/challenge-detail"
          element={<ChallengeDetail />}
        />
        <Route
          path="/feed"
          element={<FeedPage />}
        />
        <Route
          path="/feed-detail"
          element={<FeedDetail />}
        />
        <Route
          path="/feed-editor"
          element={
            <ProtectedRoute>
              <FeedEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/challenge-creation"
          element={
            <ProtectedRoute>
              <ChallengeCreation />
            </ProtectedRoute>
          }
        />
        <Route path="/login-registration" element={<LoginRegistration />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/project-dashboard"
          element={
            <ProtectedRoute>
              <ProjectDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/people"
          element={<People />}
        />
        <Route
          path="/people/user"
          element={<PeopleUser />}
        />
        <Route
          path="/proof-detail-view"
          element={<ProofDetailView />}
        />
        <Route
          path="/project-detail"
          element={<ProjectDetail />}
        />
        <Route
          path="/project-creation"
          element={
            <ProtectedRoute>
              <ProjectCreation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/neighbors"
          element={
            <ProtectedRoute>
              <NeighborsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/rankings" element={<Rankings />} />
        <Route
          path="/proof-submission"
          element={
            <ProtectedRoute>
              <ProofSubmission />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
